import { type Locale } from "./Locale";

export const supportedLocales = new Set<Locale>(["pl", "en"]);

export const defaultLocale = "en" as const;
